"use client";
import React, { useEffect, useState } from "react";
import moment from "moment";
import HTMLReactParser from "html-react-parser";
import Image from "next/image";
import { Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import "./components.css";
import { Arrow, Copy, Facebook, LinkedIn, Twitter } from "./svg";
import Link from "next/link";
import { showToast } from "../../utils/libs/toast-utilis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";

const BlogDetails = ({ blog }) => {
  const pathname = usePathname();
  const [shareUrl, setShareUrl] = useState("");
  const serviceLinks = [
    { label: "FrontEnd Development", href: "/services/frontend" },
    { label: "BackEnd Development", href: "/services/backend" },
    { label: "Database", href: "/services/database" },
    { label: "UI/UX Design", href: "/services/uiux-design" },
    {
      label: "Mobile App Development",
      href: "/services/mobile-app-development",
    },
    { label: "Cloud Services", href: "/services/cloud-services" },
    { label: "AI/ML", href: "/services/ai-ml" },
  ];

  useEffect(() => {
    if (typeof window !== "undefined" && pathname) {
      setShareUrl(window.location.origin + pathname);
    }
  }, [pathname]);
  const shareText = encodeURIComponent(blog?.title || "Check this out!");
  const cleanHTML = (html) => {
    return html.replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "");
  };
  return (
    <div>
      <Container>
        <Row className="gy-4 py-5">
          <Col md={12}>
            <h1 className="blog_heading">{blog?.title}</h1>

            <Image
              src={blog?.image?.[0]?.url || "/static-blog.png"}
              className="mb-3"
              alt={blog?.title}
              width={0}
              height={0}
              style={{
                borderRadius: "20px",
                width: "100%",
                height: "500px",
                objectFit: "cover",
              }}
              onError={(e) => {
                const target = e.target;
                if (target.src !== "/static-blog.png") {
                  target.src = "/static-blog.png";
                }
              }}
            />
            <div className="author-meta">
              <div className="author-info">
                <div className="author-img-wrapper">
                  <div className="auth-avatar author-img">
                    {blog?.author?.firstName?.charAt(0).toUpperCase()}
                  </div>
                </div>
                <p className="text-author-meta p-0 m-0">
                  by {blog?.author?.firstName} {blog?.author?.lastName}
                </p>
              </div>

              <p className="text-author-meta p-0 m-0">
                <span> Publish Date: </span>
                <span className="subtext">
                  {moment(blog?.createdAt).add(3, "days").calendar()}
                </span>
              </p>

              <p className="text-author-meta p-0 m-0">
                <span> Last Update: </span>
                <span className="subtext">June 13, 2025</span>
              </p>

              <div className="share-links">
                {typeof window !== "undefined" && (
                  <div className="share-links">
                    {/* Facebook Share */}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-facebook">
                          Share on Facebook
                        </Tooltip>
                      }
                    >
                      <div>
                        <Facebook
                          className="meta-icon"
                          onClick={() =>
                            window.open(
                              `https://www.facebook.com/neoverce.it.solutions?utm_source=website&utm_medium=blog_${blog?._id}&utm_campaign=social_redirect`,
                              "_blank"
                            )
                          }
                        />
                      </div>
                    </OverlayTrigger>

                    {/* LinkedIn Share */}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-linkedin">
                          Share on LinkedIn
                        </Tooltip>
                      }
                    >
                      <div>
                        <LinkedIn
                          className="meta-icon"
                          onClick={() =>
                            window.open(
                              `https://in.linkedin.com/company/neoverce-it-solutions-llp?utm_source=website&utm_medium=blog_${blog?._id}&utm_campaign=social_redirect`,
                              "_blank"
                            )
                          }
                        />
                      </div>
                    </OverlayTrigger>

                    {/* Instagram Share */}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-instagram">
                          View on Instagram
                        </Tooltip>
                      }
                    >
                      <div className="meta-insta-icon">
                        <FontAwesomeIcon
                          icon={faInstagram}
                          className="meta-icon"
                          onClick={() =>
                            window.open(
                              `https://www.instagram.com/neoverce_it_solutions/?utm_source=website&utm_medium=footer&utm_campaign=social_redirect#`,
                              "_blank"
                            )
                          }
                        />
                      </div>
                    </OverlayTrigger>

                    {/* Copy Link */}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-copy">Copy link</Tooltip>}
                    >
                      <div>
                        <Copy
                          className="meta-icon primary-color"
                          onClick={() => {
                            navigator.clipboard.writeText(shareUrl);
                            showToast.success("Link copied to clipboard!");
                          }}
                        />
                      </div>
                    </OverlayTrigger>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col lg={9} md={12}>
            <div>
              <div className="">
                <div className="mt-4 mb-5">
                  <div className="mt-3 blog-detail-text">
                    {HTMLReactParser(cleanHTML(String(blog?.description)))}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} md={12}>
            <div className="tag-section">
              {blog?.tags.length > 0 && (
                <>
                  <h2>Tags</h2>
                  <div className="meta-tag">
                    {blog?.tags.map((item, i) => (
                      <div className="meta-tag-pill" key={i}>
                        {item}
                      </div>
                    ))}
                  </div>
                </>
              )}
              <h2 className="mt-4">Services we provide</h2>
              <div className="service-links-blog">
                {serviceLinks.map(({ label, href }, idx) => (
                  <Link key={idx} href={href} aria-label={`view ${label} page`}>
                    <span> {label}</span>
                    <Arrow className="primary-color" />
                  </Link>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BlogDetails;
